import { useState } from "react";

export const useFormErrors = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const setFieldError = (field: string, code: string) => {
    setErrors((prev) => ({ ...prev, [field]: code }));
  };

  const clearFieldError = (field: string) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const copy = { ...prev };
      delete copy[field];
      return copy;
    });
  };

   const clearFieldsErrors = (fields: string[]) => {
     setErrors((prev) => {
       let changed = false;
       const next = { ...prev };

       fields.forEach((field) => {
         if (next[field]) {
           delete next[field];
           changed = true;
         }
       });

       return changed ? next : prev;
     });
   };

  const hasError = (field: string) => Boolean(errors[field]);
  const getErrorCode = (field: string) => errors[field];
  const resetErrors = () => setErrors({});

  return {
    errors,
    setFieldError,
    clearFieldError,
    hasError,
    getErrorCode,
    resetErrors,
    clearFieldsErrors,
  };
};
